var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutService1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.330078,
    y: 0.943359,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#33B4A0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8901 47.1618C52.8901 54.221 47.1682 59.9434 40.1101 59.9434C33.052 59.9434 27.3301 54.221 27.3301 47.1618C27.3301 45.4925 28.106 43.0733 29.3921 40.2713C30.6603 37.5081 32.3598 34.5069 34.0719 31.7221C35.782 28.9407 37.4937 26.3929 38.7788 24.5394C39.3042 23.7816 39.7578 23.1406 40.1101 22.6479C40.4624 23.1406 40.916 23.7816 41.4414 24.5394C42.7264 26.3929 44.4381 28.9407 46.1482 31.7221C47.8604 34.5069 49.5599 37.5081 50.8281 40.2713C52.1141 43.0733 52.8901 45.4925 52.8901 47.1618Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutService1);
export default __webpack_public_path__ + "static/media/about-service-1.d41a0e4eec4aab80d48b9ce6c7b4a6af.svg";
export { ForwardRef as ReactComponent };